// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9af6cdff","453":"ff105dab","667":"19cca175"}[chunkId] + ".chunk.js";
};